import { READ_ACTION_TYPES } from './action_types';
export function resetAnalysisPeriscope() {
    return { type: READ_ACTION_TYPES.RESET_ANALYSIS_PERISCOPE };
}
export function resetPeriscope() {
    return { type: READ_ACTION_TYPES.RESET_PERISCOPE };
}
